module.exports = __webpack_public_path__ + "img/message-notif.d46c6195.svg";